<template>
  <div class="o-forget-password">
    <MoleculeForgetPassword/>
  </div>
</template>

<script>
export default {
  name: 'OrganismForgetPassword',

  components: {
    MoleculeForgetPassword: () => import('@/components/molecules/MoleculeForgetPassword')
  }
}
</script>
